export default class GtagConfiguracao{
    static isGtagActive = false

    static initialize(params){
        if(params.gtagId === null)
            return

        GtagConfiguracao.createElement(params.gtagId)

        window.dataLayer = window.dataLayer || []
        window.gtag = window.gtag || function() { window.dataLayer.push(arguments) }
        window.gtag('js', new Date())
        window.gtag('config', params.gtagId)
    }

    static createElement(gtagId){
        if(!GtagConfiguracao.isGtagActive) {
            let script = document.createElement('script')
            script.setAttribute('type', 'text/javascript')
            script.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${gtagId}`)
            script.setAttribute('async', true)

            document.getElementsByTagName('head').item(0).append(script)
        }
        GtagConfiguracao.isGtagActive = true
    }
}